import { ALL_INVENTORY_BASE_URL } from '../global-constants';

/**
 * Creates a brand tile object with a consistent shape.
 *
 * @param {string} name - Brand name
 * @param {string} logoUrl - Brand logo image URL
 * @param {boolean} showLabel - Whether to show the tile label
 * @returns {{ brand: { name, brandLogoImgUrl, href, showLabel } }}
 */
export const createBrandTile = (name, logoUrl, showLabel = false) => {
	const trimmedName = name?.trim() || '';
	return {
		brand: {
			name: trimmedName,
			brandLogoImgUrl: logoUrl || '',
			href: trimmedName
				? `${ALL_INVENTORY_BASE_URL}?make=${encodeURIComponent(
						trimmedName
				  )}`
				: '',
			showLabel: !!showLabel
		}
	};
};
